import { Base } from "../../../../base/components/base"
import { Div } from "../../../../base/components/native/div"
import { tabTitleSelectedStyle, tabTitleStyle, tabTitleUnselectedStyle } from "./tab-title.style"

export const TabTitle = (id: string, title: string) => {

    const base = Div(title)

    base.cssClass(tabTitleStyle)

    base.el.onclick = () => {
        base.emit('select', id)
    }

    function select() {
        base.style(tabTitleSelectedStyle)
    }

    function unselect() {
        base.style(tabTitleUnselectedStyle)
    }

    return Object.assign(base, {
        id,
        select,
        unselect
    })
}